import { render, staticRenderFns } from "./DeleteAccountForm.vue?vue&type=template&id=24129b62&"
import script from "./DeleteAccountForm.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports